
export const mergeObjectsByNumber = (details, selectedCreditId, titleName, options, isAllReport) => {
  let mergedObjects = {};
  try {
    if (titleName === 'totals') {
      mergedObjects = details;
    } else if (titleName === 'questions') {
      mergedObjects = details.reduce((acc, item) => {
        const { courseId, questionId, ...rest } = item;
        const key = courseId + '-' + questionId;
        acc = combineBasedOnKey(acc, key, item, options);
        return acc;
      }, {});
    } else {
      mergedObjects = details.reduce((acc, item) => {
        const { number, ...rest } = item;
        acc = combineBasedOnKey(acc, number, rest, options);
        return acc;
      }, {});
    }
    const mergedDetails = Object.entries(mergedObjects).map(([number, rest]) => {
      let score = 0;
      let count = rest.correct + rest.inCorrect + rest.correctOnRetry;
      if (
        options?.scoreUnscoredCRZero &&
        (rest.crPoint === -127 ||
          rest.crPoint === -2 ||
          rest.crPoint === -1 ||
          rest.statusPoint === -127 ||
          rest.statusPoint === -2 ||
          rest.statusPoint === -1)
      ) {
        rest.statusPoint = 0;
      }

      if (
        (!options?.scoreUnscoredCRZero || isAllReport) &&
        (rest.crPoint === -127 ||
          rest.crPoint === -2 ||
          rest.crPoint === -1 ||
          rest.statusPoint === -127 ||
          rest.statusPoint === -2 ||
          rest.statusPoint === -1)
      ) {
        score = 'Not Scored';
      } else if (rest.crPoint === -1) {
        score = 'Incomplete';
      } else if (count + rest.crAnswered > 0) {
        count += rest.crMaxPoints;
        if (count > 0) {
          if (selectedCreditId == 1) {
            score = ((rest.correct + rest.crPoint) * 100) / count;
          } else if (selectedCreditId == 2) {
            score = ((rest.correct + rest.crPoint + rest.correctOnRetry / 2) * 100) / count;
          } else if (selectedCreditId == 3) {
            score = ((rest.correct + rest.crPoint + rest.correctOnRetry) * 100) / count;
          }
        }
      }

      return {
        number,
        ...rest,
        score: score
      };
    });
    const mergedDetailsWithTitle = {
      [titleName]: mergedDetails
    };

    return mergedDetailsWithTitle;
  } catch (error) {
    console.error('An error occurred while merging objects:', error);
    return [];
  }
};

function combineBasedOnKey(acc, number, rest, options) {
  if (!acc[number]) {
    acc[number] = { ...rest };
    if (
      options?.scoreUnscoredCRZero &&
      (rest.crPoint === -127 || rest.crPoint === -2 || rest.crPoint === -1)
    ) {
      acc[number].crPoint = 0;
    }
  } else {
    for (const prop in rest) {
      if (
        prop === 'score' ||
        prop === 'description' ||
        prop === 'mcChoiceDistribution' ||
        prop === 'standards' ||
        prop === 'number' ||
        prop === 'courseId' ||
        prop === 'questionId' ||
        prop === 'standardNumber' ||
        prop === 'stateId' ||
        prop === 'stateCourseId'
      ) {
        continue;
      }

      if (
        options?.scoreUnscoredCRZero &&
        prop === 'crPoint' &&
        (rest.crPoint === -127 || rest.crPoint === -2 || rest.crPoint === -1)
      ) {
        rest[prop] = 0;
        continue;
      }

      if (
        !options?.scoreUnscoredCRZero &&
        prop === 'crPoint' &&
        (rest.crPoint === -127 || rest.crPoint === -2 || rest.crPoint === -1)
      ) {
        acc[number][prop] = -127;
        continue;
      }
      if (prop === 'crPoint' && acc[number][prop] === -127) {
        continue;
      }

      if (
        !options?.scoreUnscoredCRZero &&
        prop === 'crMaxPoints' &&
        acc[number]['crPoint'] === -127
      ) {
        continue;
      }

      acc[number][prop] += rest[prop];
    }
  }
  return acc;
}

export const mainTotalTable = (report, options, selectedCreditId) => {
  const tableData = {
    totals: {
      score: 0,
      correct: 0,
      inCorrect: 0,
      correctOnRetry: 0,
      crAnswered: 0,
      courseId: null,
      crMaxPoints: 0,
      crNotAnswered: 0,
      crPoint: 0,
      notAnswered: 0
    }
  };

  const data = report?.studentResult.results.reduce((acc, value) => {
    acc.totals = resetResultStatus(value, acc.totals, options);
    return acc;
  }, tableData);

  if (options?.scoreStartedNotCompletedIncorrect) {
    tableData.totals.inCorrect += tableData.totals.notAnswered;
  }
  if (options?.scoreUnscoredCRZero) {
    tableData.totals.crAnswered += tableData.totals.crNotAnswered;
  } else if (options?.scoreStartedNotCompletedIncorrect && !options?.scoreUnscoredCRZero) {
    tableData.totals.inCorrect += tableData.totals.crNotAnswered;
  }

  tableData.score = calculateScore(
    tableData.totals,
    options,
    report?.studentResult.results.length,
    report?.studentResult.assignmentStarted
  );
  return tableData;
};

export const convertToCSV = (data, footerMessage = '') => {
  let csv = '';
  try {
    const arrayToCSV = (arr) => {
      let array;
      if (arr.length > 0 && arr[0] !== null) {
        array = [Object.keys(arr[0])].concat(arr);
      } else {
        array = [];
      }

      return array
        .map((it) => {
          return Object.values(it).toString();
        })
        .join('\n');
    };

    // Extract and sort the "score" property to be first
    const sortedData = { ...data };

    for (const [key, value] of Object.entries(sortedData)) {
      if (key !== 'ReportOptions') {
        csv = csv + key + '\n';
      }
      if (Array.isArray(value)) {
        csv = csv + arrayToCSV(value) + '\n';
        const regex = /##_.*?_##/g;
        csv = csv.replace(regex, '');
        csv = csv + '\n';
      } else if (typeof value === 'object' && value !== null) {
        for (const [childKey, childValue] of Object.entries(value)) {
          if (key === 'ReportOptions') {
            csv = csv + childKey + ': ';
          } else {
            csv = csv + childKey + '\n';
            csv = csv + '\n';
          }

          if (Array.isArray(childValue)) {
            csv = csv + arrayToCSV(childValue) + '\n';
            csv = csv + '\n';
          } else if (typeof childValue === 'object' && childValue !== null) {
            const arrayTwo = Object.values(childValue);
            csv = csv + arrayToCSV(arrayTwo[0]) + '\n';
            csv = csv + '\n';
          } else {
            csv = csv + childValue + '\n';
          }
        }
        csv = csv + '\n';
      }
    }

    // Append the footer message
    csv += footerMessage;

    return csv;
  } catch (ex) {
    console.log(ex);
  }
};

export const mergeCSVData = (csvData) => {
  let mergedCSV = '';

  for (const property in csvData) {
    if (csvData.hasOwnProperty(property)) {
      mergedCSV += `${property}\r\n${csvData[property]}\r\n`;
    }
  }

  return mergedCSV;
};

// download csv file
export const downloadCSV = (csvData, fileName) => {
  if (csvData) {
    let csvContent = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
    const link = document.createElement('a');
    link.href = csvContent;
    link.download = fileName + '.csv';
    link.click();
  }
};

// removing properties from objects
export const removePropertiesFromObjects = (obj) => {
  const propertiesToRemove = [
    'notAnswered',
    'crNotAnswered',
    'crMaxPoints',
    'number',
    'courseId',
    'stateCourseId',
    'stateId',
    'crPoint',
    'standards',
    'mcChoiceDistribution',
    'questionId'
  ];
  const newObj = { ...obj };

  Object.keys(newObj).forEach((key) => {
    if (Array.isArray(newObj[key])) {
      newObj[key] = newObj[key]
        .map((item) => {
          if (
            item.correct === 0 &&
            item.inCorrect === 0 &&
            item.correctOnRetry === 0 &&
            item.crAnswered === 0
          ) {
            return null; // Mark this item for removal
          }

          // Create a deep copy of the item without the specified properties
          const newItem = { ...item };
          propertiesToRemove.forEach((prop) => {
            delete newItem[prop];
          });

          return newItem;
        })
        .filter(Boolean); // Filter out the marked items (null) from the array
    } else if (typeof newObj[key] === 'object') {
      // Recursively call the function for nested objects
      newObj[key] = removePropertiesFromObjects(newObj[key]);
    }
  });

  return newObj;
};

// captialize first letter
export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// convert html to plain text
export const convertHtmlToPlainText = (htmlString) => {
  const parser = new DOMParser();
  const parsedHtml = parser.parseFromString(htmlString, 'text/html');
  return `"${parsedHtml.body.textContent}"`;
};

export const formatStandardsData = (data) => {
  return data.map((item) => {
    const { standardNumber, ...rest } = item;
    const formattedDescription = `${item.description} : ${standardNumber}`;
    return { ...rest, description: formattedDescription };
  });
};

export const mergeObjectsByNumberforExport = (details, selectedCreditId, titleName = '') => {
  let mergedObjects = {};
  try {
    if (titleName !== 'questions') {
      mergedObjects = details.reduce((acc, item) => {
        const { number, ...rest } = item;
        if (!acc[number]) {
          acc[number] = { ...rest };
        } else {
          for (const prop in rest) {
            if (prop === 'score' || prop === 'description') {
              continue;
            }
            if (prop === 'crPoint' && rest[prop] !== -127) {
              acc[number][prop] += typeof rest['score'] !== 'number' ? 0 : rest['score'];
              continue;
            }
            acc[number][prop] += rest[prop];
          }
        }

        return acc;
      }, {});
    } else {
      mergedObjects = details;
    }

    const mergedDetails = Object.entries(mergedObjects).map(([number, rest]) => {
      let score;
      let count = rest.correct + rest.inCorrect + rest.correctOnRetry;
      if (rest.crPoint === -127 || rest.crPoint === -2) {
        score = 'Not Scored';
      } else if (rest.crPoint === -1) {
        score = 'Incomplete';
      } else if (count + rest.crAnswered > 0) {
        count += rest.crMaxPoints;
        if (selectedCreditId == 1) {
          score = ((rest.correct + rest.crPoint) * 100) / count;
        } else if (selectedCreditId == 2) {
          score = ((rest.correct + rest.crPoint + rest.correctOnRetry / 2) * 100) / count;
        } else if (selectedCreditId == 3) {
          score = ((rest.correct + rest.crPoint + rest.correctOnRetry) * 100) / count;
        }
      } else {
        score = 0;
      }
      return {
        number,
        ...rest,
        score: score
      };
    });

    const mergedDetailsWithTitle = {
      [titleName]: mergedDetails
    };

    return mergedDetailsWithTitle;
  } catch (error) {
    console.error('An error occurred while merging objects:', error);
    return [];
  }
};

export const reorderObjectProperties = (obj, firstKey) => {
  return Object.keys(obj).reduce((acc, key) => {
    if (key === firstKey) {
      acc = { [key]: obj[key], ...acc };
    } else {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
};

export const totalTableBasedOnIdividualQueston = (report, options) => {
  const tableData = {
    teacherQuestionReport: {
      score: 0,
      correct: 0,
      inCorrect: 0,
      correctOnRetry: 0,
      crAnswered: 0,
      courseId: -2,
      crMaxPoints: 0,
      crNotAnswered: 0,
      crPoint: 0,
      notAnswered: 0
    },
    courseReport: {
      score: 0,
      correct: 0,
      inCorrect: 0,
      correctOnRetry: 0,
      crAnswered: 0,
      courseId: null,
      crMaxPoints: 0,
      crNotAnswered: 0,
      crPoint: 0,
      notAnswered: 0
    }
  };

  const data = report?.studentResult?.results?.reduce((acc, value) => {
    if (value.courseId === -2) {
      if (value.crStatus !== null) {
        if (value.crStatus) {
          // If crStatus is true, increment the crAnswered in the tableData
          acc.teacherQuestionReport.crMaxPoints += value.crStatus.maxPoints;
          if (value.crStatus.status == 'Not Answered') {
            acc.teacherQuestionReport.crNotAnswered += 1;
            acc.teacherQuestionReport.crPoint = value.crStatus.crPoint;
          } else if (value.crStatus.status == 'Answered') {
            acc.teacherQuestionReport.crAnswered += 1;
            acc.teacherQuestionReport.crPoint += value.crStatus.crPoint;
          }
        }
      } else if (value.status === 'Not Answered') {
        acc.teacherQuestionReport.notAnswered += 1;
      } else if (value.status === 'Answered') {
        acc.teacherQuestionReport.correct += 1;
      } else if (value.status === 'Incorrect') {
        acc.teacherQuestionReport.inCorrect += 1;
      } else if (value.status === 'Correct on Retry') {
        acc.teacherQuestionReport.correctOnRetry += 1;
      } else if (value.status === 'Correct') {
        acc.teacherQuestionReport.correct += 1;
      } else {
        // If the status is not 'Not Answered' or 'Answered', then it must be 'Incorrect'
        acc.teacherQuestionReport.inCorrect += 1;
      }

      if (options.scoreStartedNotCompletedIncorrect) {
        acc.teacherQuestionReport.inCorrect += acc.teacherQuestionReport.notAnswered;
      }
      if (options.scoreUnscoredCRZero) {
        acc.teacherQuestionReport.crAnswered += acc.teacherQuestionReport.crNotAnswered;
      }
    } else {
      if (value.crStatus !== null) {
        if (value.crStatus) {
          // If crStatus is true, increment the crAnswered in the tableData
          acc.courseReport.crMaxPoints += value.crStatus.maxPoints;
          if (value.crStatus.status == 'Not Answered') {
            acc.courseReport.crNotAnswered += 1;
            acc.courseReport.crPoint = value.crStatus.crPoint;
          } else if (value.crStatus.status == 'Answered') {
            acc.courseReport.crAnswered += 1;
            acc.courseReport.crPoint += value.crStatus.crPoint;
          }
        }
      } else if (value.status === 'Not Answered') {
        acc.courseReport.notAnswered += 1;
      } else if (value.status === 'Answered') {
        acc.courseReport.correct += 1;
      } else if (value.status === 'Incorrect') {
        acc.courseReport.inCorrect += 1;
      } else if (value.status === 'Correct on Retry') {
        acc.courseReport.correctOnRetry += 1;
      } else if (value.status === 'Correct') {
        acc.courseReport.correct += 1;
      } else {
        // If the status is not 'Not Answered' or 'Answered', then it must be 'Incorrect'
        acc.courseReport.inCorrect += 1;
      }

      if (options.scoreStartedNotCompletedIncorrect) {
        acc.courseReport.inCorrect += acc.courseReport.notAnswered;
      }
      if (options.scoreUnscoredCRZero) {
        acc.courseReport.crAnswered += acc.courseReport.crNotAnswered;
      }
    }

    return acc;
  }, tableData);
  return {
    teacherQuestionReport: [tableData.teacherQuestionReport],
    courseReport: [tableData.courseReport]
  };
};

export const allCumilativeReportTotals = (courseData, options, selectedCreditId) => {
  var resultData = {};
  courseData.map((item)=>{
    var courseReport= {
      score: item.courseTotal.score,
      correct: item.courseTotal.correct,
      inCorrect: item.courseTotal.inCorrect,
      correctOnRetry: item.courseTotal.correctOnRetry,
      crAnswered: item.courseTotal.crAnswered,
      courseId: item.courseTotal.courseId,
      crMaxPoints: item.courseTotal.crMaxPoints,
      crNotAnswered: item.courseTotal.crNotAnswered,
      crPoint: item.courseTotal.crPoint,
      notAnswered: item.courseTotal.notAnswered
    };

    if (options?.scoreStartedNotCompletedIncorrect) {
      courseReport.inCorrect += item.courseTotal.notAnswered;
    }
    if (options?.scoreNotStarted) {
      courseReport.crAnswered += item.courseTotal.crNotAnswered;
      courseReport.crPoint = item.courseTotal.crAnsweredPoints;
    }
    courseReport.score = calculateTeacherCumulativeScore(courseReport,selectedCreditId);

    if(courseReport.courseId == -1)
      resultData = {...resultData , teacherQuestionReportSA:[courseReport]};
    else if(courseReport.courseId == -2)
      resultData = {...resultData , teacherQuestionReportCR:[courseReport]};
    else
      resultData = {...resultData , courseReport:[courseReport]};
  });
  return resultData;
};

export const teacherCumilativeMainTotalTable = (tableData, options, selectedCreditId) => {
  const resultTotalData = {
    totals: {
      score: tableData.score,
      correct: tableData.correct,
      inCorrect: tableData.inCorrect,
      correctOnRetry: tableData.correctOnRetry,
      crAnswered: tableData.crAnswered,
      courseId: tableData.crAnswered,
      crMaxPoints: tableData.crMaxPoints,
      crNotAnswered: tableData.crNotAnswered,
      crPoint: tableData.crPoint,
      notAnswered: tableData.notAnswered
    }
  };

  if (options?.scoreStartedNotCompletedIncorrect) {
    resultTotalData.totals.inCorrect += tableData.notAnswered;
  }
  if (options?.scoreNotStarted) {
    resultTotalData.totals.crAnswered += tableData.crNotAnswered;
    resultTotalData.totals.crPoint = tableData.crAnsweredPoints;
  }
  resultTotalData.totals.score = calculateTeacherCumulativeScore(resultTotalData.totals,selectedCreditId);
  return resultTotalData;
};

function calculateTeacherCumulativeScore (tableData, retryScore){
  if (tableData.crPoint === -1) {
    return 'Incomplete';
  } else if (tableData.crPoint === -2 || tableData.crPoint === -127) {
    return 'Not Scored';
  }
  const totalQuestions = tableData.correct + tableData.inCorrect + tableData.correctOnRetry + tableData.crMaxPoints;
  
  switch (retryScore) {
  case 1:
    return Math.round((tableData.correct + tableData.crPoint) * 100 / totalQuestions);
  case 2:
    return Math.round(((tableData.correct + tableData.crPoint + (tableData.correctOnRetry / 2)) * 100) / totalQuestions);
  case 3:
    return Math.round(((tableData.correct + tableData.correctOnRetry + tableData.crPoint) * 100) / totalQuestions);
  default:
    return tableData.incompleteScoring ? '0' : ' ';
  }
}


export const cumilativeMainTotalTable = (report, options, selectedCreditId) => {
  const tableData = {
    totals: {
      score: 0,
      correct: 0,
      inCorrect: 0,
      correctOnRetry: 0,
      crAnswered: 0,
      courseId: null,
      crMaxPoints: 0,
      crNotAnswered: 0,
      crPoint: 0,
      notAnswered: 0
    }
  };
  const data = report?.studentResults?.map((item, index) => {
    item.results.reduce((acc, value) => {
      acc.totals = resetResultStatus(value, acc.totals, options, item.assignmentStarted, item.assignmentCompleted, report?.reportType);
      return acc;
    }, tableData);
  });

  if (options?.scoreStartedNotCompletedIncorrect || options?.scoreNotStarted) {
    tableData.totals.inCorrect += tableData.totals.notAnswered;
  }

  if (options?.scoreUnscoredCRZero) {
    tableData.totals.crAnswered += tableData.totals.crNotAnswered;
  } else if (options?.scoreStartedNotCompletedIncorrect && !options?.scoreUnscoredCRZero) {
    tableData.totals.inCorrect += tableData.totals.crNotAnswered;
  }
  tableData.score = calculateScore(
    tableData.totals,
    options,
    report?.studentResults?.filter(x => x.assignmentStarted).reduce((sum, studentResult) => {
      return sum + (studentResult.results.filter(r => r.status != 'Correct on previous try')?.length || 0);
    }, 0),
    true
  );

  return tableData;
};

function calculateScore(rowData, reportOptions, numberOfQuestions, assignmentStarted) {
  let count = rowData.correct + rowData.inCorrect + rowData.correctOnRetry;
  if (!assignmentStarted) {
    if (reportOptions?.scoreNotStarted) return '0';
    else return 'Not Started';
  } else if (rowData.crPoint === -127 || rowData.crPoint === -2) {
    rowData.score = 'Not Scored';
  } else if (rowData.crPoint === -1) {
    rowData.score = 'Incomplete';
  } else if (
    count + rowData.crAnswered == numberOfQuestions ||
    reportOptions?.scoreStartedNotCompletedIncorrect ||
    (!assignmentStarted && reportOptions?.scoreNotStarted)
  ) {
    count += rowData.crMaxPoints;
    if (count > 0) {
      if (reportOptions?.correctOnRetry == 1) {
        rowData.score = ((rowData.correct + rowData.crPoint) * 100) / count;
      } else if (reportOptions?.correctOnRetry == 2) {
        rowData.score =
          ((rowData.correct + rowData.crPoint + rowData.correctOnRetry / 2) * 100) / count;
      } else if (reportOptions?.correctOnRetry == 3) {
        rowData.score =
          ((rowData.correct + rowData.crPoint + rowData.correctOnRetry) * 100) / count;
      }
    }
    if (
      rowData.crAnswered + rowData.crNotAnswered == 0 &&
      count < numberOfQuestions &&
      reportOptions?.scoreStartedNotCompletedIncorrect
    ) {
      rowData.score = rowData.score / numberOfQuestions;
    }
  } else {
    rowData.score = 'Incomplete';
  }

  return rowData.score;
}

function resetResultStatus(oldResult, newResult, reportOptions, assignmentStarted, assignmentCompleted , reportType) {
  if (oldResult.status == 'Correct on previous try') return newResult;
  if (oldResult.crStatus !== null) {
    if (oldResult.crStatus) {
      newResult.crMaxPoints += oldResult.crStatus.maxPoints;

      if (
        oldResult.crStatus.status == 'Not Answered' ||
        oldResult.crStatus.status == 'In Progress'
      ) {
        newResult.crNotAnswered++;
      } else {
        newResult.crAnswered++;
      }

      if (
        oldResult.crStatus.status !== 'Answered' &&
        !reportOptions?.scoreUnscoredCRZero &&
        !reportOptions?.scoreStartedNotCompletedIncorrect
      ) {
        newResult.crPoint = -1;
        return newResult;
      } else {
        if (oldResult.crStatus.score == 127) {
          if (reportOptions?.scoreUnscoredCRZero) {
            newResult.crPoint += 0;
          } else if (
            (!reportOptions?.scoreStartedNotCompletedIncorrect ||
              (reportOptions?.scoreStartedNotCompletedIncorrect &&
                !reportOptions?.scoreUnscoredCRZero)) &&
            oldResult.crStatus.status !== 'Not Answered' && newResult.crNotAnswered == 0 && newResult.notAnswered == 0
          ) {
            newResult.crPoint = -2;
            return newResult;
          }
        }

        if (
          oldResult.crStatus.score >= 0 &&
          oldResult.crStatus.score != 127 &&
          newResult.crPoint >= 0
        ) {
          newResult.crPoint += oldResult.crStatus.score;
        }
      }
    }
  }
  else if ((reportOptions?.scoreStartedNotCompletedIncorrect && assignmentStarted && !assignmentCompleted && oldResult.status === 'Not Answered') ||
    (reportOptions?.scoreNotStarted && !assignmentStarted && oldResult.status == null) && reportType == 2) {
    newResult.notAnswered++;
  } else if (oldResult.status === 'Not Answered' && reportType != 2)
    newResult.notAnswered++;
  else if (oldResult.status === 'Answered' || oldResult.status === 'Correct') {
    newResult.correct++;
  } else if (oldResult.status === 'Incorrect' || oldResult.status === 'Incorrect on Retry') {
    newResult.inCorrect++;
  } else if (oldResult.status === 'Correct on Retry') {
    newResult.correctOnRetry++;
  }
  return newResult;
}


export const cumilativeReportTotals = (report, options) => {
  const tableData = {
    teacherQuestionReport: {
      score: 0,
      correct: 0,
      inCorrect: 0,
      correctOnRetry: 0,
      crAnswered: 0,
      courseId: -2,
      crMaxPoints: 0,
      crNotAnswered: 0,
      crPoint: 0,
      notAnswered: 0
    },
    courseReport: {
      score: 0,
      correct: 0,
      inCorrect: 0,
      correctOnRetry: 0,
      crAnswered: 0,
      courseId: null,
      crMaxPoints: 0,
      crNotAnswered: 0,
      crPoint: 0,
      notAnswered: 0
    }
  };
  const data = report?.studentResults
    ?.filter((item) => item.assignmentStarted === true)
    .map((item, index) => {
      item.results.reduce((acc, value) => {
        if (value.courseId === -2 || value.courseId === -1) {
          acc.teacherQuestionReport = resetResultStatus(value, acc.teacherQuestionReport, options, item.assignmentStarted, item.assignmentCompleted , report?.reportType);
        } else if (value.courseId != 0) {
          acc.courseReport = resetResultStatus(value, acc.courseReport, options);
        }
        return acc;
      }, tableData);
    });
  if (options.scoreStartedNotCompletedIncorrect) {
    tableData.courseReport.inCorrect += tableData.courseReport.notAnswered;
    tableData.teacherQuestionReport.inCorrect += tableData.teacherQuestionReport.notAnswered;
  }
  if (options.scoreUnscoredCRZero) {
    tableData.courseReport.crAnswered += tableData.courseReport.crNotAnswered;
    tableData.teacherQuestionReport.crAnswered += tableData.teacherQuestionReport.crNotAnswered;
  }
  return {
    teacherQuestionReport: [tableData.teacherQuestionReport],
    courseReport: [tableData.courseReport]
  };
};

export const cumulativeIndividualScore = (reportData, reportOptions) => {
  var modifiedCumilativeReportData = { ...reportData };

  modifiedCumilativeReportData.studentResults = reportData?.studentResults?.map((item, index) => {
    const updatedItem = { ...item };
    const tableData = {
      score: 0,
      correct: 0,
      inCorrect: 0,
      correctOnRetry: 0,
      crAnswered: 0,
      courseId: null,
      crMaxPoints: 0,
      crNotAnswered: 0,
      crPoint: 0,
      notAnswered: 0
    };
    updatedItem.totals = item.results.reduce((acc, value) => {
      acc = resetResultStatus(value, acc, reportOptions, item.assignmentStarted, item.assignmentCompleted, reportData?.reportType);
      return acc;
    }, tableData);

    if (reportOptions?.scoreStartedNotCompletedIncorrect || reportOptions?.scoreNotStarted) {
      updatedItem.totals.inCorrect += updatedItem.totals.notAnswered;
    }
    // if (reportOptions?.scoreUnscoredCRZero) {
    //   updatedItem.totals.crAnswered += updatedItem.totals.crNotAnswered;
    // } else if (
    //   reportOptions?.scoreStartedNotCompletedIncorrect &&
    //   !reportOptions?.scoreUnscoredCRZero
    // ) {
    //   updatedItem.totals.inCorrect += updatedItem.totals.crNotAnswered;
    // }
    updatedItem.score = calculateScore(
      updatedItem.totals,
      reportOptions,
      item.results.filter(r => r.status !== 'Correct on previous try').length,
      item.assignmentStarted
    );
    return updatedItem;

  });
  return modifiedCumilativeReportData;
};

export const transformKeysAndValues = (obj) => {
  const keyMapping = {
    score: 'Score',
    correct: 'C',
    inCorrect: 'X',
    correctOnRetry: 'R',
    crAnswered: 'CR'
  };

  for (const mainKey in obj) {
    if (obj.hasOwnProperty(mainKey)) {
      const mainValue = obj[mainKey];
      for (const item of mainValue) {
        // Update keys based on the keyMapping
        for (const oldKey in keyMapping) {
          if (item.hasOwnProperty(oldKey)) {
            const newKey = keyMapping[oldKey];
            item[newKey] = item[oldKey];
            delete item[oldKey];
          }
        }
      }
    }
  }

  return obj;
};

export const reportOptionsBasedScoreCalculation = (data, sessionReportOptions) => {
  let result;
  result = data.map((item) => {
    const updatedTopics = item?.topics?.map((topic) => {
      return {
        ...topic,
        inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
          ? topic.inCorrect + topic.notAnswered
          : topic.inCorrect,
        crAnswered: sessionReportOptions.scoreUnscoredCRZero
          ? topic.crAnswered + topic.crNotAnswered
          : topic.crAnswered
      };
    });

    const updatedStandards = item?.standards?.map((standard) => ({
      ...standard,
      inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
        ? standard.inCorrect + standard.notAnswered
        : standard.inCorrect,
      crAnswered: sessionReportOptions.scoreUnscoredCRZero
        ? standard.crAnswered + standard.crNotAnswered
        : standard.crAnswered
    }));

    const updatedTags = item?.tags?.map((tag) => ({
      ...tag,
      inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
        ? tag.inCorrect + tag.notAnswered
        : tag.inCorrect,
      crAnswered: sessionReportOptions.scoreUnscoredCRZero
        ? tag.crAnswered + tag.crNotAnswered
        : tag.crAnswered
    }));

    const updatedLevels = item?.level?.map((level) => ({
      ...level,
      inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
        ? level.inCorrect + level.notAnswered
        : level.inCorrect,
      crAnswered: sessionReportOptions.scoreUnscoredCRZero
        ? level.crAnswered + level.crNotAnswered
        : level.crAnswered
    }));

    const updatedAttribute = item?.attribute?.map((attribute) => ({
      ...attribute,
      inCorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect
        ? attribute.inCorrect + attribute.notAnswered
        : attribute.inCorrect,
      crAnswered: sessionReportOptions.scoreUnscoredCRZero
        ? attribute.crAnswered + attribute.crNotAnswered
        : attribute.crAnswered
    }));

    return {
      ...item,
      topics: updatedTopics,
      standards: updatedStandards,
      tags: updatedTags,
      level: updatedLevels,
      attribute: updatedAttribute,
      courseId: item.courseName == 'Teacher Questions - Short Answer ' ? -2 : item.courseId
    };
  });

  return result;
};